/**
 * @enum {String}
 */
module.exports = {
    PARENT: 'parent',
    CHILD: 'child'
};
